<template>
  <a-modal
    :footer="null"
    :width="660"
    :afterClose="handleAfterClose"
    v-model:visible="visible"
    :maskClosable="false"
    :title="$t('shopping_cart.upload_modal_title')"
  >
    <div>
      <input
        @change="handleFileChange"
        type="file"
        ref="upload"
        style="display: none;"
        :accept="excelFormat.join(',')"
      />
      <div v-if="file" class="file-info">
        <div>{{ file.name }}</div>

        <DeleteIcon @click="handleDeleteFile" class="delete-icon" />
      </div>
      <a-button
        v-if="!file"
        @click="$refs.upload.click()"
        class="select-btn j-height-auto j-outline-btn1"
      >
        {{ '+ ' + $t('shopping_cart.upload_modal_select_file') }}
      </a-button>
    </div>

    <div class="action-container">
      <div class="file-action">
        <div class="file-btn" @click="downloadTemplate">
          <DownloadIcon class="icon" />

          <span>{{ $t('shopping_cart.template') }}</span>
        </div>
        <div class="file-btn" @click="handlePreviousFile">
          <HistoryIcon class="icon" />

          <span>{{ $t('shopping_cart.previous_file') }}</span>
        </div>
      </div>

      <div class="btn-action">
        <a-button
          :loading="loading"
          class="j-outline-btn1 j-height-auto"
          @click="visible = false"
          >{{ $t('shopping_cart.cancel') }}</a-button
        >
        <a-button
          :disabled="!file"
          type="primary"
          :loading="loading"
          class="j-height-auto"
          @click="handleConfirm"
          >{{ $t('shopping_cart.confirm') }}</a-button
        >
      </div>
    </div>
  </a-modal>
</template>

<script lang="ts">
import { defineComponent, h } from 'vue';
import { mapState } from 'vuex';
import { message } from 'ant-design-vue';
import HistoryIcon from '@/components/icons/HistoryIcon.vue';
import DownloadIcon from '@/components/icons/DownloadIcon.vue';
import DeleteIcon from '@/components/icons/DeleteIcon.vue';
import { getTemplateFile, importPartFile } from '@/api/apis';
import UploadTemplateMessage from './UploadTemplateMessage.vue';
import { mapActions } from 'vuex';

const excelFormat = [
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-excel'
];

export default defineComponent({
  name: 'UploadModal',
  components: {
    HistoryIcon,
    DownloadIcon,
    DeleteIcon
    // UploadTemplateMessage
  },
  data() {
    return {
      loading: false,
      excelFormat,
      visible: true,
      isCancel: true,
      file: null
    };
  },
  computed: {
    ...mapState(['lang'])
  },
  emits: ['after-close'],
  methods: {
    ...mapActions(['reloadMsg']),
    handleAfterClose() {
      this.$emit('after-close', this.isCancel);
    },
    // show previous data
    handlePreviousFile() {
      this.isCancel = false;

      this.visible = false;
    },
    async handleConfirm() {
      this.loading = true;

      const fd = new FormData();

      fd.append('file', this.file as any);

      // const res = await importPartFile({
      //   file: fd
      // });

      const res = await importPartFile(fd);

      if (res.success) {

        await this.reloadMsg();

        this.isCancel = false;
        this.visible = false;
      } else {
        message.error({
          content: h(UploadTemplateMessage, {
            message: this.$t(res.message),
            result: (res.result || []).join(','),
            showNum: false
          })
        });
      }

      this.loading = false;
    },
    async downloadTemplate() {
      await getTemplateFile(`${this.$t('shopping_cart.part_template')}.xlsx`, {
        type: 6,
        local: this.lang
      });
    },
    handleDeleteFile() {
      this.file = null;
    },
    handleFileChange(e) {
      const files = e.target.files || [];

      if (files.length > 0) {
        const file = files[0];

        if (excelFormat.includes(file.type)) {
          this.file = file;
        } else {
          message.warn(this.$t('shopping_cart.wrong_file_format'));
        }
      }

      e.target.value = '';
    }
  }
});
</script>

<style lang="scss" scoped>
.select-btn {
  width: 100%;
  margin: 20px 0 40px 0;
}

.action-container {
  display: flex;
  align-items: center;
  justify-content: space-between;

  .file-action {
    flex: 1;
    display: flex;
    align-items: center;
    color: $primary-color;

    .file-btn {
      &:first-child {
        margin-right: 32px;
      }
      cursor: pointer;
    }

    .icon {
      margin-right: 12px;
    }

    &:hover {
      color: $primary-hover-color;
    }
  }

  .btn-action {
    flex: 1;
    display: flex;
    align-items: center;

    &::v-deep(.ant-btn) {
      flex: 1;
      &:first-child {
        margin-right: 20px;
      }
    }
  }
}

.file-info {
  padding: 10px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: $table-even-row-bg-color;
  margin-bottom: 40px;

  .delete-icon {
    cursor: pointer;
  }
}
</style>
